import {StoreListService} from '~/app/core/common/services/store-list.service';
import {Nomenclatures} from '~/app/core/common/enums/Nomenclatures';
import {ProfileCategoriesService} from '~/app/core/common/services/profile-categories.service';
import {DialogHelperComponent} from '~/app/shared/helpers/dialog-helper';
import {DeviceHelperComponent} from '~/app/shared/helpers/device-helper';
import {KendoGridHelperComponent} from '~/app/shared/helpers/kendo-grid-helper';
import {TextFieldHelperComponent} from '~/app/shared/helpers/text-field-helper';
import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ProfileService} from '~/app/core/common/services/profile.service';
import {FilterableListPickerHelper} from '~/app/shared/helpers/filterable-list-picker-helper';
import {ProfileItem} from '~/app/core/common/models/profileItem';
import {CustomerCategory} from '~/app/core/common/models/customerCategory';
import {RadlistviewHelperComponent} from '~/app/shared/helpers/radlistview-helper';
import {ComponentCanDeactivate} from '~/app/shared/navigation/component-can-deactivate';
import {SearchBarHelperComponent} from '~/app/shared/helpers/searchBar-helper';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {InternetConnectionService} from '~/app/shared/services/internet-connection.service';
import {DatabaseHelper} from '~/app/shared/helpers/database-helper';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import { ToastService } from '../helpers/toast-service';

@Component({
    selector: 'app-profile-categories',
    templateUrl: './profile-categories.component.html',
    styleUrls: ['./profile-categories.component.scss'] // TODO general UI changes found during testing / add common css to common file
})
export class ProfileCategoriesComponent extends ComponentCanDeactivate implements OnInit {
    get allItemsListView(): ProfileItem[] {
        return this._allItemsListView;
    }

    set allItemsListView(value: ProfileItem[]) {
        this._allItemsListView = value;
    }

    private _isTablet: boolean;
    private _iOS: boolean;
    @ViewChild('categoryListPicker', {
        static: false
    }) private _categoryListPicker: ElementRef;
    @ViewChild('allItemRadListView', {
        static: false
    }) private _allItemRadListView: ElementRef;
    @ViewChild('categoryItemRadListView', {
        static: false
    }) private _categoryItemRadListView: ElementRef;
    private _columns: any[] = [{
        field: 'customerItem',
        title: Nomenclatures.ITEM_NUMBER,
        width: '100',
        filterable: true
    }];
    private _state: any;
    private _stateCategory: any;
    private _categoryListView: string[] = this._profileCategoriesService.customerCategories.map(category => category.description).filter(e => e !== 'ALL ITEMS');
    private _allItemsListView: ProfileItem[] = this.profileService.profileItem.items.filter(category => category.categoryDescription === 'ALL ITEMS');
    // private _categoryListView: string[];
    // private _allItemsListView: ProfileItem[];
    private _categoryItemsListView: ProfileItem[] = [];
    private _selectedCategory: string;
    private _gridData: any;
    private _gridDataForCategory: any;
    private _totalItemsInTable = 0;
    private _totalItemsInTableCategory = 0;
    private _allItemsSelected: ProfileItem[] = [];
    private _categoryItemsSelected: ProfileItem[] = [];
    private _newCategoryTextValue: string="";
    private _selectedIndex = 0;

    constructor(public _profileCategoriesService: ProfileCategoriesService,
                private _storeListService: StoreListService,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
                private _profileService: ProfileService,
                public internetConnectionService: InternetConnectionService,
                private _ref: ChangeDetectorRef,
                private _dialogHelper: DialogHelperComponent,
                private _deviceHelper: DeviceHelperComponent,
                private _kendoHelper: KendoGridHelperComponent,
                private _filterableListPickerHelper: FilterableListPickerHelper,
                private _radlistViewHelpder: RadlistviewHelperComponent,
                private _textFieldHelper: TextFieldHelperComponent,
                private _searchBarHelper: SearchBarHelperComponent,
                private _databaseHelper: DatabaseHelper,
                public applicationSettingsHelper: ApplicationSettingsHelper,
                private toaster:ToastService
    ) {
        super();
    }

    get profileService(): ProfileService {
        return this._profileService;
    }

    get dialogHelper(): DialogHelperComponent {
        return this._dialogHelper;
    }

    get deviceHelper(): DeviceHelperComponent {
        return this._deviceHelper;
    }

    get kendoHelper(): KendoGridHelperComponent {
        return this._kendoHelper;
    }

    get filterableListPickerHelper(): FilterableListPickerHelper {
        return this._filterableListPickerHelper;
    }

    get textFieldHelper(): TextFieldHelperComponent {
        return this._textFieldHelper;
    }

    get columns(): any[] {
        return this._columns;
    }

    set columns(value: any[]) {
        this._columns = value;
    }

    get state(): any {
        return this._state;
    }

    set state(value: any) {
        this._state = value;
    }

    get stateCategory(): any {
        return this._stateCategory;
    }

    set stateCategory(value: any) {
        this._stateCategory = value;
    }

    get categoryListView(): string[] {
        return this._categoryListView;
    }

    set categoryListView(value: string[]) {
        this._categoryListView = value;
    }

    get categoryItemsListView(): ProfileItem[] {
        return this._categoryItemsListView;
    }

    set categoryItemsListView(value: ProfileItem[]) {
        this._categoryItemsListView = value;
    }

    get selectedCategory(): string {
        return this._selectedCategory;
    }

    set selectedCategory(value: string) {
        this._selectedCategory = value;
    }

    get gridData(): any {
        return this._gridData;
    }

    set gridData(value: any) {
        this._gridData = value;
    }

    get gridDataForCategory(): any {
        return this._gridDataForCategory;
    }

    set gridDataForCategory(value: any) {
        this._gridDataForCategory = value;
    }

    get totalItemsInTable(): number {
        return this._totalItemsInTable;
    }

    set totalItemsInTable(value: number) {
        this._totalItemsInTable = value;
    }

    get totalItemsInTableCategory(): number {
        return this._totalItemsInTableCategory;
    }

    set totalItemsInTableCategory(value: number) {
        this._totalItemsInTableCategory = value;
    }

    get allItemsSelected(): ProfileItem[] {
        return this._allItemsSelected;
    }

    set allItemsSelected(value: ProfileItem[]) {
        this._allItemsSelected = value;
    }

    get categoryItemsSelected(): ProfileItem[] {
        return this._categoryItemsSelected;
    }

    set categoryItemsSelected(value: ProfileItem[]) {
        this._categoryItemsSelected = value;
    }

    get newCategoryTextValue(): string {
        return this._newCategoryTextValue;
    }

    set newCategoryTextValue(value: string) {
        this._newCategoryTextValue = value;
    }

    get selectedIndex(): number {
        return this._selectedIndex;
    }

    set selectedIndex(value: number) {
        this._selectedIndex = value;
    }

    get selectedCallback(): (args) => any {
        return this._selectedCallback;
    }

    get selectedCallbackItems(): (args) => any {
        return this._selectedCallbackItems;
    }

    async ngOnInit() {
        const options = {
            message: 'Loading...',
        };
        this._loadingIndicatorHelper.show(options);
        // this.categoryListView = this._profileCategoriesService.customerCategories.map(category => category.description).filter(e => e !== 'ALL ITEMS');
        // this.allItemsListView = this.profileService.profileItem.items.filter(category => category.categoryDescription === 'ALL ITEMS');
        this._isTablet = this.deviceHelper.isTablet();
        this._iOS = this.deviceHelper.isiOS();
        if (!this._isTablet) {
            this.deviceHelper.setOrientation('landscape');
            this.deviceHelper.disableRotation();
        }
        this.state = this.kendoHelper.state;
        this.stateCategory = this.kendoHelper.stateCategory;
        if (this._profileCategoriesService.selectedCategory.description === 'ALL ITEMS') {
            this._profileCategoriesService.customerCategories.sort((a, b) => {
                return (a.description < b.description ? 1 : -1);
            }).find(e => {
                if (e.description !== 'ALL ITEMS') {
                    this._profileCategoriesService.customerCategories.forEach(cat => {
                        if (cat.description === e.description && cat.description !== 'CRITICAL ITEMS' && cat.description !== 'HOLD ITEMS') {
                            cat.selected = true;
                            this._profileCategoriesService.selectedCategory = cat;
                            this.selectedCategory = this._profileCategoriesService.selectedCategory.description;
                        } else {
                            cat.selected = false;
                        }
                    });
                }
            });
        } else {
            this.selectedCategory = this._profileCategoriesService.selectedCategory.description;
        }
        this.updateAllItemsListView();
        this.updateCategoryListView();
        // this.applicationSettingsHelper.setSelectedProfileTab('1');
        // this._profileService.selectedIndex = +this.applicationSettingsHelper.getSelectedProfileTab();
        this._loadingIndicatorHelper.hide();
    }

    updateAllItemsListView() {
        this.kendoHelper.process(this.allItemsListView, this.state);
        this.gridData = this.kendoHelper._gridDataHelper;
        this.totalItemsInTable = this.allItemsListView.length;
        this.kendoHelper.restartStateCategory();
    }

    updateCategoryListView() {
        this.categoryItemsListView = this.profileService.profileItem.items.filter(category => this.selectedCategory === category.categoryDescription && category.categoryItemRemove !== true);
        this.kendoHelper.processCategory(this.categoryItemsListView, this.stateCategory);
        this.gridDataForCategory = this.kendoHelper._gridDataHelperCategory;
        this.totalItemsInTableCategory = this.categoryItemsListView.length;
        this.kendoHelper.restartStateCategory();
        this.profileService.updateProfileItemListView();
    }

    async addCategoryClicked() {
        let add = true;
        if (this.internetConnectionService.isEnabled) {
            const options = {
                message: 'Loading...',
            };
            this._loadingIndicatorHelper.show(options);
            let displayCategory: string;
            if (this.newCategoryTextValue !== undefined && this.newCategoryTextValue !== '') {
                displayCategory = this.newCategoryTextValue.toString().toUpperCase().trim();
                this._profileCategoriesService.customerCategories.find(e => {
                    if (e.description === displayCategory) {
                        add = false;
                        this.dialogHelper.showOkErrorDialog(Nomenclatures.ERROR, Nomenclatures.CATEGORY_ALREADY_EXISTS);
                    }
                });
                if (add) {
                    const pickedCustomerId = await this._storeListService.pickedCustomerIdVerify();
                    await this._profileCategoriesService.addCategory(displayCategory.split(' ').join('+'), pickedCustomerId.toString())
                        .then((uniqueCategoryId: any) => {
                            this.addCategory(displayCategory, uniqueCategoryId);
                        });
                }
            } else {
                this.toaster.showToastError(Nomenclatures.TOAST_CATEGORY_PLEASE_ENTER_A_CATEGORY, Nomenclatures.ERROR, +Nomenclatures.TIMEOUT2000);
            }
            this._loadingIndicatorHelper.hide();
        } else {
            this.toaster.showToastError(Nomenclatures.NO_INTERNET_CONNECTION, Nomenclatures.ERROR, +Nomenclatures.TIMEOUT4000);
        }
    }

    addCategory(displayCategory: string, uniqueCategoryId: number) {
        this._profileCategoriesService.customerCategories.forEach(cat => {
            cat.selected = false;
        });
        const database = this._databaseHelper.getDatabase();
        if (database !== false) {
            // @ts-ignore
            database.createDocument(new CustomerCategory(uniqueCategoryId, (uniqueCategoryId + 1) + '', displayCategory, true, 'customer_categories'));
            console.log('Category Added to DB!');
        }
        this._profileCategoriesService.customerCategories.push(new CustomerCategory(uniqueCategoryId, (uniqueCategoryId + 1) + '', displayCategory, true, 'customer_categories'));
        this._profileCategoriesService.originalList = this._profileCategoriesService.customerCategories;
        this._profileCategoriesService.selectedCategory = this._profileCategoriesService.customerCategories.find(category => category.description === displayCategory);
        this.selectedCategory = this._profileCategoriesService.selectedCategory.description;
        this._profileCategoriesService.updateCategoryList();
        this.newCategoryTextValue = '';
        this.updateCategoryListView();
        this.toaster.showToastInfo(displayCategory, Nomenclatures.TOAST_CATEGORY_ADDED, +Nomenclatures.TIMEOUT2000);
    }

    async deleteCategoryClicked() {
        if (this.internetConnectionService.isEnabled) {
            let result: boolean;
            if (this._profileCategoriesService.selectedCategory.description === 'CUSTOMIZED LIST') {
                this.toaster.showToastError(Nomenclatures.TOAST_DELETE_ERROR, Nomenclatures.TOAST_TITLE_INVALID_SELECTION, +Nomenclatures.TIMEOUT2000);
            } else {
                result = await this.dialogHelper
                    .showConfirmDialogYesNo(Nomenclatures.DIALOG_DELETE_CATEGORY,
                        Nomenclatures.DIALOG_DELETE_CATEGORY_MSG + this._profileCategoriesService.selectedCategory.description + '?');
                if (result) {
                    const options = {
                        message: 'Loading...',
                    };
                    this._loadingIndicatorHelper.show(options);
                    await this._profileCategoriesService
                        .deleteCategory(this._profileCategoriesService.selectedCategory.uniqueCategoryId.toString())
                        .then(() => {
                            this.toaster.showToastInfo(this._profileCategoriesService.selectedCategory.description, Nomenclatures.TOAST_CATEGORY_DELETED, +Nomenclatures.TIMEOUT2000);
                            this.deleteCategoryConfirmed();
                        }).catch((error_msg) => alert(error_msg));
                    this._loadingIndicatorHelper.hide();
                }
            }
        } else {
            this.toaster.showToastError(Nomenclatures.NO_INTERNET_CONNECTION, Nomenclatures.ERROR, +Nomenclatures.TIMEOUT4000);
        }
    }

    deleteCategoryConfirmed() {
        this.selectedIndex = this._profileCategoriesService.customerCategories.indexOf(this._profileCategoriesService.selectedCategory);
        const database = this._databaseHelper.getDatabase();
        if (database !== false) {
            // @ts-ignore
            const documents = database.query({
                select: [],
                where: [{property: 'documentType', comparison: 'equalTo', value: 'customer_categories'}]
            });
            // @ts-ignore
            documents.filter(category => {
                if (this._profileCategoriesService.selectedCategory.uniqueCategoryId === category.uniqueCategoryId) {
                    const documentId = category.id;
                    // @ts-ignore
                    database.deleteDocument(documentId);
                    console.log('Category Deleted From DB: ' + documentId);
                }
            });
        }
        this._profileCategoriesService.customerCategories.splice(this.selectedIndex, 1);
        this._profileCategoriesService.originalList = this._profileCategoriesService.customerCategories;
        this._profileCategoriesService.selectedCategory = this._profileCategoriesService.customerCategories.find(d => d);
        if (this._profileCategoriesService.selectedCategory.description === 'ALL ITEMS') {
            this._profileCategoriesService.customerCategories.sort((a, b) => {
                return (a.description < b.description ? 1 : -1);
            }).find(e => {
                if (e.description !== 'ALL ITEMS' && e.description !== 'HOLD ITEMS' && e.description !== 'CRITICAL ITEMS') {
                    this._profileCategoriesService.selectedCategory = e;
                    this.selectedCategory = this._profileCategoriesService.selectedCategory.description;
                }
            });
        } else {
            this._profileCategoriesService.customerCategories.sort((a, b) => {
                return (a.description < b.description ? 1 : -1);
            }).find(e => {
                if (e.description !== 'ALL ITEMS' && e.description !== 'HOLD ITEMS' && e.description !== 'CRITICAL ITEMS') {
                    this._profileCategoriesService.selectedCategory = e;
                    this._profileCategoriesService.selectedCategory.selected = true;
                    this.selectedCategory = e.description;
                }
            });
        }
        this._profileCategoriesService.updateCategoryList();
        this.updateCategoryListView();
    }

    selectedCategoryOption(args) {
        if (args.selectedItem === undefined) {
            this._profileCategoriesService.customerCategories.forEach(cat => {
                if (cat.description === args) {
                    cat.selected = true;
                    this._profileCategoriesService.selectedCategory = cat;
                } else {
                    cat.selected = false;
                }
            });
        } else {
            this._profileCategoriesService.selectedCategory = this._profileCategoriesService.customerCategories.find(category => category.description === args.selectedItem);
            this.selectedCategory = this._profileCategoriesService.selectedCategory.description;
        }

        this._profileCategoriesService.customerCategories.sort((a, b) => {
            return (a.description > b.description ? 1 : -1);
        });
        this.updateCategoryListView();
    }

    copyBtnClicked() {
        let duplicate: boolean;
        const database = this._databaseHelper.getDatabase();
        this.allItemsSelected.forEach(item => {
                let index: number;
                this.profileService.itemsSaved = true;
                duplicate = false;
                let itemExisted = false;
                this.profileService.profileItem.items.forEach(pItem => {
                    if (item.customerItemId === pItem.customerItemId && item.categoryDescription === 'ALL ITEMS' && pItem.categoryItemRemove) {
                        index = this.profileService.profileItem.items.indexOf(pItem);
                        this.profileService.profileItem.items.splice(index, 1);
                        // @ts-ignore
                        const documents = database.query({
                            select: [],
                            where: [{property: 'documentType', comparison: 'equalTo', value: 'profile_item'}]
                        });
                        // @ts-ignore
                        documents.forEach(profileDoc => {
                            if (item.customerItemId === profileDoc.customerItemId && item.categoryDescription === 'ALL ITEMS' && profileDoc.categoryItemRemove) {
                                const documentId = profileDoc.id;
                                // @ts-ignore
                                database.deleteDocument(documentId);
                                console.log('Profile Item Deleted From DB: ' + documentId);
                            }
                        });
                        this.profileService.profileItem.items.push(this.categoryItemReset(pItem));
                        if (database !== false) {
                            // @ts-ignore
                            database.createDocument(this.categoryItemReset(pItem));
                            this.applicationSettingsHelper.setProfileCategoryChangesSaved(true);
                            console.log('Profile Item Added to DB!');
                        }
                        itemExisted = true;
                    }
                });
                if (itemExisted) {
                    this.categoryItemsListView = this.profileService.profileItem.items.filter(category => this.selectedCategory === category.categoryDescription && category.categoryItemRemove !== true);
                }
                this.categoryItemsListView.forEach(e => {
                    if (e.customerItemId === item.customerItemId && e.categoryId === this._profileCategoriesService.selectedCategory.uniqueCategoryId) {
                        duplicate = true;
                    }
                });
                if (!duplicate) {
                    if (database !== false) {
                        // @ts-ignore
                        database.createDocument(this.categoryItemAdd(item));
                        this.applicationSettingsHelper.setProfileCategoryChangesSaved(true);
                        console.log('Profile Item Added to DB! ' + item.customerItem);
                    }
                    this.profileService.profileItem.items.push(this.categoryItemAdd(item));
                }
            }
        );
        if (this._allItemRadListView !== undefined) {
            this._radlistViewHelpder.clearSelected((this._allItemRadListView.nativeElement));
        }
        this.updateCategoryListView();
        this.clearGridSelections();
    }

    removeBtnClicked() {
        this.categoryItemsSelected.forEach(item => {
            let index: number;
            const database = this._databaseHelper.getDatabase();
            if (item.categoryItemAdd) {
                index = this.profileService.profileItem.items.indexOf(item);
                this.profileService.profileItem.items.splice(index, 1);
                if (database !== false) {
                    // @ts-ignore
                    const documents = database.query({
                        select: [],
                        where: [{property: 'documentType', comparison: 'equalTo', value: 'profile_item'}]
                    });
                    // @ts-ignore
                    documents.forEach(profileDoc => {
                        if (item.customerItem === profileDoc.customerItem && item.categoryDescription === profileDoc.categoryDescription) {
                            const documentId = profileDoc.id;
                            // @ts-ignore
                            database.deleteDocument(profileDoc.customerItem);
                            this.applicationSettingsHelper.setProfileCategoryChangesSaved(true);
                            console.log('Profile Item Deleted From DB: ' + documentId);
                        }
                    });
                }
            } else {
                index = this.profileService.profileItem.items.indexOf(item);
                this.profileService.profileItem.items.splice(index, 1);
                this.profileService.profileItem.items.push(this.categoryItemRemove(item));
                if (database !== false) {
                    // @ts-ignore
                    const documents = database.query({
                        select: [],
                        where: [{property: 'documentType', comparison: 'equalTo', value: 'profile_item'}]
                    });
                    // @ts-ignore
                    documents.forEach(profileDoc => {
                        if (item.customerItem === profileDoc.customerItem && item.categoryDescription === profileDoc.categoryDescription) {
                            const documentId = profileDoc.id;
                            // @ts-ignore
                            database.deleteDocument(documentId);
                            console.log('Profile Item Deleted From DB: ' + documentId);
                        }
                    });
                    this.applicationSettingsHelper.setProfileCategoryChangesSaved(true);
                    // @ts-ignore
                    database.createDocument(this.categoryItemRemove(item));
                    console.log('Profile Item Added to DB!');
                }
            }
            this.profileService.itemsSaved = true;
        });
        if (this._allItemRadListView !== undefined) {
            this._radlistViewHelpder.clearSelected((this._categoryItemRadListView.nativeElement));
        }
        this.updateCategoryListView();
        this.clearGridSelections();
    }

    async saveItems() {
        await this.profileService.saveAllItems();
        this.profileService.updateProfileItemListView();
    }

    newCategoryTextBoxChanged(newValue) {
        this.newCategoryTextValue = newValue;
    }

    clearGridSelections() {
        // TODO clear mobile selected with helper
        this.allItemsSelected = [];
        this.categoryItemsSelected = [];
    }

    onAllItemsListViewSelected(args) {
        const listView = this._radlistViewHelpder.getListView(args);
        this.allItemsSelected = <ProfileItem[]>listView.getSelectedItems();
    }

    onCategoryItemsListViewSelected(args) {
        const listView = this._radlistViewHelpder.getListView(args);
        this.categoryItemsSelected = <ProfileItem[]>listView.getSelectedItems();
    }

    showCategoryPicker() {
        this._categoryListPicker.nativeElement.show(this.filterableListPickerHelper.getFrame());
    }

    dataStateChange(state: any) {
        this.state = state;
        this.kendoHelper.process(this.allItemsListView, this.state);
        this.gridData = this.kendoHelper._gridDataHelper;
        this.totalItemsInTable = this.gridData.total;
    }

    dataStateChangeCategory(state: any) {
        this.stateCategory = state;
        this.kendoHelper.processCategory(this.categoryItemsListView, this.stateCategory);
        this.gridDataForCategory = this.kendoHelper._gridDataHelperCategory;
        this.totalItemsInTableCategory = this.gridDataForCategory.total;
    }

    pageChange($event) {
        this.kendoHelper.pageChange($event);
    }

    pageChangeCategory($event) {
        this.kendoHelper.pageChangeCategory($event);
    }

    canDeactivate(): boolean {
        return !this._profileService.itemsSaved;
    }

    categoryItemAdd(item: ProfileItem): ProfileItem {
        return {
            description: item.description,
            categoryDescription: this._profileCategoriesService.selectedCategory.description,
            sequence: item.sequence,
            critical: item.critical,
            show: item.show,
            buildToQty: item.buildToQty,
            uom: item.uom,
            customerItemId: item.customerItemId,
            ledgerCode: item.ledgerCode,
            locationIds: item.locationIds,
            inventoryFrequency: item.inventoryFrequency,
            categoryId: this._profileCategoriesService.selectedCategory.uniqueCategoryId,
            maxQty: item.maxQty,
            customerItem: item.customerItem,
            hasError: item.hasError,
            updated: false,
            categoryItemAdd: true,
            categoryItemRemove: false,
            documentType: 'profile_item',


        };
    }

    categoryItemRemove(item: ProfileItem): ProfileItem {
        return {
            description: item.description,
            categoryDescription: this._profileCategoriesService.selectedCategory.description,
            sequence: item.sequence,
            critical: item.critical,
            show: item.show,
            buildToQty: item.buildToQty,
            uom: item.uom,
            customerItemId: item.customerItemId,
            ledgerCode: item.ledgerCode,
            locationIds: item.locationIds,
            inventoryFrequency: item.inventoryFrequency,
            categoryId: this._profileCategoriesService.selectedCategory.uniqueCategoryId,
            maxQty: item.maxQty,
            customerItem: item.customerItem,
            hasError: item.hasError,
            updated: false,
            categoryItemAdd: false,
            categoryItemRemove: true,
            documentType: 'profile_item'
        };
    }

    categoryItemReset(item: ProfileItem): ProfileItem {
        return {
            description: item.description,
            categoryDescription: this._profileCategoriesService.selectedCategory.description,
            sequence: item.sequence,
            critical: item.critical,
            show: item.show,
            buildToQty: item.buildToQty,
            uom: item.uom,
            customerItemId: item.customerItemId,
            ledgerCode: item.ledgerCode,
            locationIds: item.locationIds,
            inventoryFrequency: item.inventoryFrequency,
            categoryId: this._profileCategoriesService.selectedCategory.uniqueCategoryId,
            maxQty: item.maxQty,
            customerItem: item.customerItem,
            hasError: item.hasError,
            updated: false,
            categoryItemAdd: false,
            categoryItemRemove: false,
            documentType: 'profile_item'
        };
    }

    keyChangeAdd(event){
        this.allItemsSelected=event;
    }
    keyChangeRemove(event){
        this.categoryItemsSelected=event;
    }
    private _selectedCallback = (args) => args.dataItem;

    private _selectedCallbackItems = (args) => args.dataItem;
}
